"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeAddresses = exports.removeAddresses = exports.getAddresses = exports.setAddresses = void 0;

var _types = require("../types");

var _initialState = require("../context/initialState");

var _stringConversion = _interopRequireDefault(require("./stringConversion"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var setAddresses = function setAddresses(savedAddresses) {
  window && window.localStorage && window.localStorage.setItem(_types.KEY, (0, _stringConversion["default"])(savedAddresses));
};

exports.setAddresses = setAddresses;

var getAddresses = function getAddresses() {
  // tslint:disable-next-line
  if (typeof window === 'undefined') {
    return undefined;
  }

  var addresses = window.localStorage.getItem(_types.KEY);
  return addresses && (0, _stringConversion["default"])(addresses);
};

exports.getAddresses = getAddresses;

var removeAddresses = function removeAddresses() {
  window && window.localStorage && window.localStorage.removeItem(_types.KEY);
};

exports.removeAddresses = removeAddresses;

var initializeAddresses = function initializeAddresses() {
  window && window.localStorage && !window.localStorage.getItem(_types.KEY) && setAddresses(_initialState.initialState);
};

exports.initializeAddresses = initializeAddresses;